import { useGetAttachmentDownloadUrl } from './use-get-attachment-download-url';

export const useDownloadAttachment = () => {
  const getAttachmentDownloadUrl = useGetAttachmentDownloadUrl();

  const onDownload = async (data: {
    hbDriveId: string;
    name: string;
  }): Promise<void> => {
    const { url } = await getAttachmentDownloadUrl.mutateAsync(data);

    if (!url) {
      throw new Error('Invalid download URL received');
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = data.name;
    link.style.display = 'none';
    // eslint-disable-next-line @cspell/spellchecker
    link.rel = 'noopener,noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return onDownload;
};
